import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/alliance/alliance-logo.png';
import _imports_1 from '@/assets/alliance/alliance-logo@2x.png';
import _imports_2 from '@/assets/alliance/alliance-logo@3x.png';

const _withScopeId = n => (_pushScopeId("data-v-75183f3d"), n = n(), _popScopeId(), n);

const _hoisted_1 = _imports_1 + ' 2x, ' + _imports_2 + ' 3x';

const _hoisted_2 = {
  class: "block"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  srcset: _hoisted_1,
  alt: "block"
}, null, -1));

const _hoisted_4 = /*#__PURE__*/_createTextVNode("The First Alliance");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" The First Alliance will be launched in August. We look forward to your participation and join us now for full technical support! ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_block_with_image = _resolveComponent("block-with-image");

  return _openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_block_with_image, {
    imagePosition: "left"
  }, {
    image: _withCtx(() => [_hoisted_3]),
    title: _withCtx(() => [_hoisted_4]),
    content: _withCtx(() => [_hoisted_5]),
    _: 1
  })]);
}